import {
  FormControlLabel,
  Checkbox,
  Card,
  FormGroup,
  CardContent,
  Tooltip,
  IconButton,
  Collapse,
} from "@material-ui/core";
import { surveyFrequency } from "../../../utils/utils";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import EmailInvitationBody from "../../../components/EmailInvitationBody";
import EmailPreview from "../../../components/EmailPreview";
import { formatDateToDisplay } from "../../../utils/dateUtils";

const SurveyCard = ({
  surveyName,
  emailValue,
  onEmailChange,
  selectedFrequency,
  handleFrequencyChange,
  assignSurveyHandler,
  expanded,
  handleExpandClick,
  handleEditorChange,
  emailBody,
  emailErrorMsg,
  scheduleDate,
  prevFrequency,
}) => {
  return (
    <Card variant="outlined" className="mb-2">
      <CardContent>
        <CardContent>
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center btn-styling">
              <label className="sub-heading">
                <b>Survey: {surveyName}</b>
              </label>
              <Tooltip title={expanded ? "Collapse" : "Expand"}>
                <IconButton
                  onClick={() => handleExpandClick(surveyName)}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  {expanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Collapse in={expanded}>
            <div className="form-group row">
              <label className="col-sm-3 form-control-label required label">
                Email Addresses
              </label>
              <div className="col-sm-9">
                <textarea
                  name="emails"
                  rows={5}
                  id="emails"
                  placeholder="Emails"
                  className="form-control form-control-success fields-font"
                  onChange={(e) => onEmailChange(e, surveyName)}
                  value={emailValue}
                />
                {emailErrorMsg != "" && (
                  <span className="error">{emailErrorMsg}</span>
                )}
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-3 form-control-label required label">
                Survey Frequency
              </label>
              <div className="col-sm-9 d-flex align-items-center gap-3">
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedFrequency === surveyFrequency.oneTime}
                        onChange={() =>
                          handleFrequencyChange(surveyFrequency.oneTime)
                        }
                      />
                    }
                    label="One Time"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedFrequency === surveyFrequency.weekly}
                        onChange={() =>
                          handleFrequencyChange(surveyFrequency.weekly)
                        }
                      />
                    }
                    label="Weekly"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedFrequency === surveyFrequency.monthly}
                        onChange={() =>
                          handleFrequencyChange(surveyFrequency.monthly)
                        }
                      />
                    }
                    label="Monthly"
                  />
                </FormGroup>
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-3 form-control-label label">
                Status
              </label>
              {scheduleDate.surveyFrequency !== null &&
                scheduleDate.surveyFrequency !== undefined &&
                scheduleDate.surveyFrequency !== "no-value" && (
                  <div className="col-sm-9">
                    <label className="font-bold">
                      <b>
                        Scheduled {scheduleDate.surveyFrequency} since{" "}
                        {formatDateToDisplay(scheduleDate.modifiedDate)}
                      </b>
                    </label>
                  </div>
                )}
            </div>

            <EmailInvitationBody
              emailBody={emailBody}
              handleEditorChange={(content, editor) =>
                handleEditorChange(content, editor, surveyName)
              }
            />

            <div className="form-group row">
              <div className="col-sm-9 offset-sm-3">
                <button
                  type="button"
                  disabled={
                    selectedFrequency === null ||
                    selectedFrequency === undefined ||
                    (selectedFrequency === "no-value" &&
                      prevFrequency === undefined) ||
                    (selectedFrequency === prevFrequency &&
                      prevFrequency === "no-value") ||
                    emailValue.trim() === "" ||
                    emailErrorMsg !== ""
                  }
                  onClick={assignSurveyHandler}
                  className="btn btn-submit float-right buttons"
                >
                  {prevFrequency === "no-value" || prevFrequency === undefined
                    ? "Assign Survey"
                    : "Update Survey"}
                </button>
              </div>
            </div>
            <EmailPreview mailBody={emailBody} />
          </Collapse>
        </CardContent>
      </CardContent>
    </Card>
  );
};

export default SurveyCard;
